import { OffsetDateTime } from "@js-joda/core";
import BloodPressureClassification from "./BloodPressureClassification";

export type BloodPressureReading = {
  id: string;
  patientId: string;
  dateTime: OffsetDateTime;
  bloodPressure: string;
  classification: BloodPressureClassification;
};

export type BloodPressureReadingApiDto = {
  id: string;
  patientId: string;
  dateTime: string;
  bloodPressure: string;
  classification: BloodPressureClassification;
};

export const toBloodPressureReading = (dto: BloodPressureReadingApiDto): BloodPressureReading => ({
  ...dto,
  dateTime: OffsetDateTime.parse(dto.dateTime),
});
